import {AxiosRequest, HttpUtils} from '../../../utils/HttpUtils';
import {PersonSearchCondition} from "../dto/PersonSearchCondition";

export const PersonApi = {

    queryPersons: async (body: PersonSearchCondition) => {
        try {
            const requestUrl = '/exos/v4/person/query';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
